import _map from "lodash/map"
import _filter from "lodash/filter"
import _uniqWith from "lodash/uniqWith"
import _isEqual from "lodash/isEqual"
import _get from "lodash/get"
import find from "ramda/src/find"
import propEq from "ramda/src/propEq"
import filter from "ramda/src/filter"
import sortBy from "ramda/src/sortBy"
import prop from "ramda/src/prop"
import compose from "ramda/src/compose"
import * as ActionTypes from "services/state/action-types"
import { setCustomer } from "services/network/auth"
import { ACTIVE } from "./constants"
import { customerAdapter } from "./adapter"

function findActiveContacts(contacts = []) {
  const filtering = filter(propEq("contactStatus", ACTIVE))
  const ordering = sortBy(prop("name"))

  return compose(ordering, filtering)(contacts)
}

function findContactById(contactId) {
  return find(propEq("contactId", contactId))
}

const CUSTOMER_INITIAL_STATE = {
  loading: false,
  error: false,
  success: false,
  data: [],
  contact: null,
  contacts: { data: [], active: { data: [] } },
  parent: null,
  sendMailSuccess: false,
  lastUpdate: null,
  lastEmailUpdate: null,
  addressByZipCode: [],
  subscription: null,
  validatePassword: { isValidPassword: false, loading: false },
  changePassword: false
}

export function customer(state = CUSTOMER_INITIAL_STATE, action) {
  let contacts, parent, contactId, data, contact
  let oldCustomerData, documentNumber, emBase64
  let resultGenerateToken

  switch (action.type) {
    case ActionTypes.GET_CUSTOMER:
      return {
        ...state,
        loading: true,
        data: action.payload.data
      }

    case ActionTypes.UPDATE_CUSTOMER_SUCCESS:
      data = action.payload.data
      parent = state.parent || data
      contacts = data.contacts

      contacts = {
        data: contacts,
        active: { data: findActiveContacts(contacts) }
      }

      return {
        ...state,
        data,
        contacts,
        parent: { ...parent },
        loading: false,
        error: false,
        success: true
      }

    case ActionTypes.GET_CUSTOMER_SUCCESS:
    case ActionTypes.REMOVE_CONTACT_SUCCESS:
    case ActionTypes.CREATE_USER_SUCCESS:
      data = customerAdapter(action.payload.data)
      parent = state.parent || data
      contacts = data.contacts

      oldCustomerData = window.localStorage.getItem("customerData")
        ? JSON.parse(window.localStorage.getItem("customerData"))
        : null

      if (!oldCustomerData || data !== oldCustomerData) {
        window.localStorage.setItem("customerData", JSON.stringify(data))
      }

      contacts = {
        data: contacts,
        active: { data: findActiveContacts(contacts) }
      }

      documentNumber = _get(data, "documentNumber", "")
      emBase64 = btoa(documentNumber)

      setCustomer(emBase64)

      return {
        ...state,
        data,
        contacts,
        parent: { ...parent },
        loading: false,
        error: false
      }

    case ActionTypes.CREATE_CONTACT_SUCCESS:
    case ActionTypes.UPDATE_CONTACT_SUCCESS:
      data = action.payload.data

      return {
        ...state,
        data,
        loading: false,
        error: false,
        success: true
      }

    case ActionTypes.LIST_CONFIG_VALUES_SUCCESS:
      return {
        ...state,
        notificationMethods: action.payload.data,
        loading: false,
        error: false,
        success: true
      }

    case ActionTypes.LIST_CONFIG_VALUES_FAIL:
      return { ...state, loading: false, error: true }

    case ActionTypes.ZIP_CODE_ADDRESS:
      return { ...state, loading: true, error: false }

    case ActionTypes.ZIP_CODE_ADDRESS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        addressByZipCode: action.payload.data.resultData
      }

    case ActionTypes.ZIP_CODE_ADDRESS_FAIL:
      return { ...state, loading: false, error: true }

    case ActionTypes.GET_CUSTOMER_FAIL:
      return { ...state, loading: false, error: true }

    case ActionTypes.GET_CONTACT:
      contactId = action.payload
      contacts = state.contacts.data
      contact = findContactById(contactId)(contacts)

      if (contact.gender) {
        contact.genderCode = contact.gender === "Feminino" ? "1" : "2"
      }
      if (contact.sendingType) {
        contact.contactMethod = contact.sendingType === "E-MAIL" ? "1" : "2"
      }

      return { ...state, contact }

    case ActionTypes.CHANGE_CUSTOMER:
      return { ...CUSTOMER_INITIAL_STATE, parent: { ...state.parent } }

    case ActionTypes.SEND_MAIL:
      return { ...state, sendMailSuccess: false, loading: true }

    case ActionTypes.SEND_MAIL_SUCCESS:
      return { ...state, sendMailSuccess: true, loading: false }

    case ActionTypes.SEND_MAIL_FAIL:
      return { ...state, sendMailSuccess: false, loading: false }

    case ActionTypes.SET_LAST_CUSTOMER_UPDATE:
      return { ...state, lastUpdate: action.payload }

    case ActionTypes.SET_LAST_EMAIL_UPDATE:
      return { ...state, lastEmailUpdate: action.payload }

    case ActionTypes.UPDATE_RECEIVING_PROTOCOL:
      return { ...state, loading: true }

    case ActionTypes.UPDATE_RECEIVING_PROTOCOL_SUCCESS:
      return { ...state, loading: false }

    case ActionTypes.UPDATE_RECEIVING_PROTOCOL_FAIL:
      return { ...state, loading: false, error: true }

    case ActionTypes.RESET_ERROR_EDIT_CUSTOMER:
      return { ...state, error: false, success: false }

    case ActionTypes.GET_SUBSCRIPTION:
      return { ...state, loading: true }

    case ActionTypes.GET_SUBSCRIPTION_SUCCESS:
      return { ...state, subscription: action.payload, loading: false }

    case ActionTypes.GET_SUBSCRIPTION_FAIL:
      return { ...state, loading: false, error: true }

    case ActionTypes.VALIDATE_CUSTOMER_PASSWORD:
      return {
        ...state,
        loading: false,
        error: false,
        sucess: false,
        changePassword: false,
        validatePassword: action.load
      }

    case ActionTypes.VALIDATE_CUSTOMER_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        validatePassword: { isValidPassword: true, loading: false }
      }

    case ActionTypes.VALIDATE_CUSTOMER_PASSWORD_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        validatePassword: { isValidPassword: false, loading: false }
      }

    case ActionTypes.CHANGE_CUSTOMER_PASSWORD:
      return {
        ...state,
        loading: false,
        error: false,
        success: false,
        validatePassword: action.load
      }

    case ActionTypes.CHANGE_CUSTOMER_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        validatePassword: { loading: false },
        changePassword: true
      }

    case ActionTypes.CHANGE_CUSTOMER_PASSWORD_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        success: false,
        validatePassword: { loading: false },
        changePassword: false
      }

    case ActionTypes.GET_CUSTOMER_AWS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        data: { ...state.data, customerInfo: action.payload.data }
      }

    case ActionTypes.GET_CUSTOMER_AWS_FAIL:
      return { ...state, loading: false, error: true, success: false }

    case ActionTypes.DISABLE_ALIAS_TUTORIAL:
      return { ...state, loading: false, error: false, success: false }

    case ActionTypes.DISABLE_ALIAS_TUTORIAL_SUCCESS:
      return { ...state, loading: false, error: false, success: true }

    case ActionTypes.DISABLE_ALIAS_TUTORIAL_FAIL:
      return { ...state, loading: false, error: true, success: false }

    case ActionTypes.GENERATE_TOKEN:
      return { ...state, loading: true }

    case ActionTypes.GENERATE_TOKEN_SUCCESS:
      resultGenerateToken = {
        ...state,
        loading: false,
        error: false,
        success: true,
        data: {
          ...state.data,
          customerToken: {
            token: _get(action, "payload.data.messageKey", ""),
            isValid: false
          }
        }
      }
      return resultGenerateToken

    case ActionTypes.GENERATE_TOKEN_FAIL:
      return { ...state, loading: false, error: true }

    case ActionTypes.AUTH_TOKEN:
      return { ...state, loading: true }

    case ActionTypes.AUTH_TOKEN_FAIL:
      return { ...state, loading: false, error: true, success: false }

    case ActionTypes.AUTH_TOKEN_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        data: {
          ...state.data,
          customerToken: {
            ...state.data.customerToken,
            isValid: true
          }
        }
      }

    case ActionTypes.FIND_CUSTOMER_TICKETS:
      return { ...state }

    case ActionTypes.FIND_CUSTOMER_TICKETS_FAIL:
      return { ...state, loading: false, error: true, success: false }

    case ActionTypes.FIND_CUSTOMER_TICKETS_SUCCESS:
      state.data.customerTickets = mountTickets(
        _get(action, "payload.data.rewardCouponList", [])
      )
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        data: state.data
      }

    case ActionTypes.SIGN_IN_SUBSIDIARY:
      return {
        ...state,
        loading: true
      }

    case ActionTypes.SIGN_IN_SUBSIDIARY_SUCCESS:
    case ActionTypes.SIGN_IN_SUBSIDIARY_FAIL:
      return {
        ...state,
        loading: false
      }

    default:
      return state
  }
}

function mountTickets(customerTickets) {
  const SEMANAL = "SEMANAL"
  const MENSAL = "MENSAL"
  const SEMESTRAL = "SEMESTRAL"
  const QUINZENAL = "QUINZENAL"

  const weeklyTickets = customerTickets.filter(
    (ticket) => ticket.frequencyType === SEMANAL
  )
  const monthlyTickets = customerTickets.filter(
    (ticket) => ticket.frequencyType === MENSAL
  )
  const biannualTickets = customerTickets.filter(
    (ticket) => ticket.frequencyType === SEMESTRAL
  )
  const biweeklyTickets = customerTickets.filter(
    (ticket) => ticket.frequencyType === QUINZENAL
  )

  return {
    weeklyTickets,
    monthlyTickets,
    biannualTickets,
    biweeklyTickets
  }
}

function normalize({
  data,
  federativeUnit,
  locality,
  streetName,
  neighborhood
}) {
  const address = {
    ...data,
    federativeUnit: federativeUnit || data.federativeUnit,
    locality: locality || data.locality,
    streetName: streetName || data.streetName,
    neighborhood: neighborhood || data.neighborhood
  }
  return address
}

const mapFederationUnity = (payload) =>
  _uniqWith(
    _map(payload, (item) => ({
      label: item.state.code,
      value: item.state.id,
      name: item.state.name
    })),
    _isEqual
  )

const mapLocalities = (payload) =>
  _uniqWith(
    _map(payload, (item) => ({
      label: item.city.locality.name,
      value: item.city.id,
      name: item.city.name
    })),
    _isEqual
  )

const mapStreets = (payload) =>
  _uniqWith(
    _map(payload, (item) => ({
      label: `${item.street.streetName.streetType} ${item.street.streetName.name}`,
      name: `${item.street.streetName.name}`,
      value: item.street.id,
      streetTypeCode: item.street.streetName.streetTypeCode,
      streetType: item.street.streetName.streetType,
      nameType: item.street.streetName.nameType
    })),
    _isEqual
  )

const mapNeighbourhoods = (payload) =>
  _uniqWith(
    _map(payload, (item) => ({
      label: item.street.neighbourhood[0].name,
      value: item.street.neighbourhood[0].id
    })),
    _isEqual
  )

const filterAddress = (payload, selecteds) =>
  mapStreets(
    _filter(payload, (item) => item.city.locality.name === selecteds.locality)
  )

const filterNeighbourhoods = (payload, selecteds) =>
  mapNeighbourhoods(
    _filter(
      payload,
      (item) =>
        item.city.locality.name === selecteds.locality &&
        `${item.street.streetName.streetType} ${item.street.streetName.name}` ===
          selecteds.streetName
    )
  )

const MODAL_INITIAL_STATE = {
  open: false,
  userData: {},
  data: {},
  originalAddress: [],
  selecteds: {},
  selectedCleared: false,
  loading: false,
  error: false,
  success: false,
  result: null,
  errorBillResult: null,
  resultBill: null,
  errorBill: false,
  finish: false
}

export function modal(state = MODAL_INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.GET_ADDRESS_SUCCESS: {
      return { ...state, userData: action.payload }
    }

    case ActionTypes.UPDATE_BILL:
      return { ...state, loading: true, success: false, errorBill: false }

    case ActionTypes.UPDATE_BILL_SUCCESS:
      return {
        ...state,
        resultBill: _get(action, "payload.data.resultData", null),
        loading: false,
        errorBill: false,
        success: true
      }

    case ActionTypes.UPDATE_BILL_FAIL: {
      const errorResult = action.error.data || action.error.response.data

      return {
        ...state,
        loading: false,
        errorBill: true,
        errorBillResult: errorResult,
        name: action.meta.previousAction.name
      }
    }

    case ActionTypes.UPDATE_ADDRESS:
      return { ...state, loading: true, finish: false }

    case ActionTypes.UPDATE_ADDRESS_SUCCESS:
      return { ...state, result: action, loading: false, finish: true }

    case ActionTypes.UPDATE_ADDRESS_FAIL:
      return {
        ...state,
        result: action.error.response.data,
        loading: false,
        error: true,
        finish: true
      }

    case ActionTypes.GET_TYPE_COMPLEMENT_SUCCESS: {
      const data = action.payload
      return { ...state, data }
    }

    case ActionTypes.SET_ADDRESS_BY_ZIPCODE: {
      const federationUnity = mapFederationUnity(action.payload.data.resultData)

      const localities = mapLocalities(action.payload.data.resultData)

      const addresses = mapStreets(action.payload.data.resultData)

      const neighbourhoods = mapNeighbourhoods(action.payload.data.resultData)

      const data = normalize({
        data: state.data,
        federativeUnit: federationUnity,
        locality: localities,
        city: localities,
        streetName: addresses,
        neighborhood: neighbourhoods
      })

      return {
        ...state,
        data,
        originalAddress: action.payload.data.resultData,
        selecteds: {
          federativeUnit: federationUnity[0].label,
          locality: localities[0].label,
          streetName: addresses[0].label,
          nameType: addresses[0].nameType,
          city: localities[0].name,
          neighborhood: neighbourhoods[0].label
        }
      }
    }

    case ActionTypes.OPEN_MODAL:
      return { ...state, open: true }

    case ActionTypes.CLOSE_MODAL:
      return { ...state, open: false }

    case ActionTypes.CLEAR_ADDRESS_SELECTEDS:
      return { ...state, selecteds: {}, selectedCleared: true }

    case ActionTypes.CLEAR_ADDRESS_ZIPCODE: {
      const { data } = state
      delete data.zipCode
      return { ...state, data }
    }

    case "RESET_ADDRESS":
      return {
        ...state,
        data: normalize({
          data: state.data,
          federativeUnit: [],
          locality: [],
          streetName: [],
          city: [],
          neighborhood: []
        }),
        selecteds: {
          federativeUnit: "",
          locality: "",
          streetName: "",
          city: "",
          neighborhood: ""
        },
        selectedCleared: true
      }

    case ActionTypes.UPDATE_ADDRESS_LOCALITY: {
      const selecteds = {}

      selecteds.federativeUnit = state.data.federativeUnit[0].label
      selecteds.locality = _filter(
        state.data.locality,
        (item) => item.value === action.payload
      )[0].label

      const address = filterAddress(state.originalAddress, selecteds)

      selecteds.streetName = address[0].label

      const neighbourhoods = filterNeighbourhoods(
        state.originalAddress,
        selecteds
      )

      selecteds.neighborhood = neighbourhoods[0].label

      const data = normalize({
        data: state.data,
        streetName: address,
        neighborhood: neighbourhoods
      })

      return {
        ...state,
        data,
        selecteds
      }
    }

    case ActionTypes.UPDATE_ADDRESS_STREET: {
      const selecteds = {}

      selecteds.federativeUnit = state.data.federativeUnit[0].label
      selecteds.locality = _filter(
        state.data.locality,
        (item) => item.value === action.payload.locality
      )[0].label
      selecteds.streetName = _filter(
        state.data.streetName,
        (item) => item.value === action.payload.streetName
      )[0].label

      const neighbourhoods = filterNeighbourhoods(
        state.originalAddress,
        selecteds
      )

      selecteds.neighborhood = neighbourhoods[0].label

      const data = normalize({
        data: state.data,
        neighborhood: neighbourhoods
      })

      return {
        ...state,
        data,
        selecteds
      }
    }

    case ActionTypes.SET_MODAL_CUSTOMER:
      return {
        ...state,
        error: false,
        errorBill: false,
        result: null,
        errorBillResult: null,
        resultBill: null,
        success: false
      }

    case ActionTypes.CHANGE_CUSTOMER:
      return { ...MODAL_INITIAL_STATE }

    default:
      return state
  }
}

const DEACTIVATE_DIGITAL_INITIAL_STATE = {
  error: false,
  success: true,
  loading: false
}

export function deactivateDigitalAccount(
  state = DEACTIVATE_DIGITAL_INITIAL_STATE,
  action
) {
  switch (action.type) {
    case ActionTypes.DEACTIVATE_DIGITAL_ACCOUNT:
      return { ...state, loading: true, error: false, success: false }

    case ActionTypes.DEACTIVATE_DIGITAL_ACCOUNT_SUCCESS:
      return { ...state, loading: false, error: false, success: true }

    case ActionTypes.DEACTIVATE_DIGITAL_ACCOUNT_FAIL:
      return { ...state, loading: false, error: true, success: false }

    default:
      return state
  }
}

const CUSTOMER_OPEN_INVOICES_INITIAL_STATE = {
  error: false,
  success: true,
  loading: false,
  payload: true
}

export function customerOpenInvoices(
  state = CUSTOMER_OPEN_INVOICES_INITIAL_STATE,
  action
) {
  switch (action.type) {
    case ActionTypes.FIND_CUSTOMER_OPEN_INVOICES:
      return { ...state, loading: true, success: false, error: false }

    case ActionTypes.FIND_CUSTOMER_OPEN_INVOICES_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        action: action.payload.data,
        data: action.payload.data,
        error: false
      }

    case ActionTypes.FIND_CUSTOMER_OPEN_INVOICES_FAIL:
      return { ...state, loading: false, success: false, error: true }

    case ActionTypes.FILTER_INVOICES:
      return { ...state, loading: true, error: false }

    case ActionTypes.FILTER_INVOICES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        payload: action.payload.data,
        data: action.payload.data
      }

    case ActionTypes.FILTER_INVOICES_FAIL:
      return { ...state, loading: false, error: true }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/services/state/customer/reducer.js